// Framework and third-party non-UI
import React from 'react';

// Redux, contexts, and local helpers/utils/modules

// Component specific modules (Component-styled, etc.)

// App components

// Third-party components (buttons, icons, etc.)
import { CalciteCheckbox } from '@esri/calcite-components-react';

interface CalciteCheckboxWrapperProps
  extends Omit<React.ComponentProps<typeof CalciteCheckbox>, 'onChange'> {
  onChange: (value: boolean) => void;
}

const CalciteCheckboxWrapper = ({
  checked,
  disabled,
  onChange,
  ...rest
}: CalciteCheckboxWrapperProps) => {
  const onCalciteCheckboxChange = (e: any) => {
    onChange((e.target as HTMLCalciteCheckboxElement).checked as boolean);
  };

  return (
    <CalciteCheckbox
      checked={checked || undefined}
      disabled={disabled || undefined}
      onCalciteCheckboxChange={onCalciteCheckboxChange}
      {...rest}
    />
  );
};

export default CalciteCheckboxWrapper;
